import './auth.scss'
import React, { useEffect, useState } from 'react'
import {
  LoginForm,
  SignupForm,
  ForgotPassword,
  ConfirmSignUp,
  ResetPassword,
} from './Forms'
import { AuthContext } from './AuthContext'

export const Login = ({
  modal,
  setTitle = () => {},
  setPage = () => {},
  page = 'signup',
  showGoogle = true,
  onShowOtherLogin,
  onSuccess: externalOnSuccess
}) => {
  const [step, setStep] = useState(page)
  const [payload, setPayload] = useState({ email: '' })
  useEffect(() => {
    setPage(step)
  }, [step])
  const onSuccess = async () => {
    if (externalOnSuccess) {
      externalOnSuccess()
    } else if (modal) {
      window.location.reload()
    } else {
      window.location.href = '/dashboard'
    }
  }
  const showStep = () => {
    switch (step) {
      case 'login':
        setTitle('Login to your account')
        return <LoginForm showGoogle={showGoogle} onShowOtherLogin={onShowOtherLogin} />
      case 'signup':
        setTitle('Create your Tripsha Account')
        return <SignupForm showGoogle={showGoogle} onShowOtherLogin={onShowOtherLogin} />
      case 'confirm-email':
        setTitle('Check your email')
        return <ConfirmSignUp />
      case 'forgot-password':
        setTitle('Recover your password')
        return <ForgotPassword />
      case 'reset-password':
        setTitle('Enter new password')
        return <ResetPassword />
      default:
        return <LoginForm onShowOtherLogin={onShowOtherLogin} />
    }
  }
  const authContext = {
    step,
    setStep,
    payload,
    setPayload,
    onSuccess,
  }
  return (
    <AuthContext.Provider value={authContext}>
      <div className="auth-container">{showStep()}</div>
    </AuthContext.Provider>
  )
}
